
export type CreateSession200 = {
  /** 세션 최대 유지 시간 (초) */
  maxInactiveInterval?: number;
  message?: string;
  sessionId?: string;
  success?: boolean;
  userId?: string;
};
